import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { BrowserRouter } from "react-router-dom"
import axios from "axios";
import './index.css';
import * as serviceWorker from './serviceWorker';
import LandingReducer from './Store/reducers/LandingReducer';
import SearchRdrucer from './Store/reducers/SearchReducer';
import DetailReducer from './Store/reducers/DetailReducer';
import AuthReducer from './Store/reducers/AuthReducer';
import WishListReducer from './Store/reducers/WishListReducer';
import DealerReducer from './Store/reducers/DealerReducer';
import ProfileReducer from './Store/reducers/ProfileReducer';
import MessagesReducer from "./Store/reducers/MessagesReducers";
import ChatReducer from "./Store/reducers/ChatReducer";
import ContactNowReducers from "./Store/reducers/ContactNowReducers"
import App from './App';

axios.defaults.baseURL = 'https://apis-staging.auto.pcari.my/api/v1/';

const logger = store => {
  return next => {
    return action => {
      // console.log('MiddleWare', action)
      const result = next(action);
      console.log('MidlleWare-2', store.getState())
      return result;
    }
  }
}
//redux dev Tool
//const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

const rootReducer = combineReducers({
  landingP: LandingReducer,
  SearchP: SearchRdrucer,
  DetailP:DetailReducer,
  Auth:AuthReducer,
  WishList : WishListReducer,
  DealerP : DealerReducer,
  Profile: ProfileReducer,
  Messages : MessagesReducer,
  Chat: ChatReducer,
  ContactNow: ContactNowReducers
})

const store = createStore(rootReducer, compose(applyMiddleware(logger, thunk))) 
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
